import React, { useState, useEffect, Suspense, lazy, useRef } from 'react';
import './App.css';
import HeroHeader from './components/HeroHeader';
import QuoteSection from './components/QuoteSection';
import CountdownTimer from './components/CountdownTimer';
import InvitationVideo from './components/InvitationVideo';
import bgMusic from './assets/bksong.mp3'; // Import the music file

const CoupleIntro = lazy(() => import('./components/CoupleIntro'));
const WeddingDetails = lazy(() => import('./components/WeddingDetails'));
const Timeline = lazy(() => import('./components/Timeline'));
const CoupleNote = lazy(() => import('./components/CoupleNote'));
const RsvpSection = lazy(() => import('./components/RsvpSection'));
const PhotoGallery = lazy(() => import('./components/PhotoGallery'));
const Footer = lazy(() => import('./components/Footer'));

function App() {
  const [showVideo, setShowVideo] = useState(true);
  const [isSoundOn, setIsSoundOn] = useState(false);
  const audioRef = useRef(null);

  // Reset scroll position to top on page refresh
  useEffect(() => {
    window.scrollTo(0, 0);
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  // Control body scroll based on video visibility
  useEffect(() => {
    if (showVideo) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showVideo]);

  const handleVideoEnd = () => {
    setShowVideo(false);
    window.scrollTo(0, 0);
  };

  // Function to be called from InvitationVideo to start the music
  const startMusic = () => {
    if (audioRef.current) {
      audioRef.current.play().then(() => {
        setIsSoundOn(true);
      }).catch(() => {
        // In case of any error, ensure state is correct
        setIsSoundOn(false);
      });
    }
  };

  // Function to be passed to HeroHeader to toggle the music
  const toggleMusic = () => {
    if (audioRef.current) {
      if (audioRef.current.paused) {
        audioRef.current.play().then(() => setIsSoundOn(true));
      } else {
        audioRef.current.pause();
        setIsSoundOn(false);
      }
    }
  };

  return (
    <div className="App">
      {/* Audio element is now here, at the top level */}
      <audio ref={audioRef} src={bgMusic} loop playsInline preload="auto" />

      {showVideo && <InvitationVideo onVideoEnd={handleVideoEnd} onPlayMusic={startMusic} />}
      
      <div className={`main-content ${showVideo ? 'hidden' : 'visible'}`}>
        <HeroHeader isSoundOn={isSoundOn} togglePlay={toggleMusic} />
        <QuoteSection />
        <CountdownTimer />
        <Suspense fallback={<div>Loading...</div>}>
          <CoupleIntro />
          <div id="details">
            <WeddingDetails />
            <Timeline />
          </div>
          <CoupleNote />
          <div id="rsvp">
            <RsvpSection />
          </div>
          <div id="gallery">
            <PhotoGallery />
          </div>
          <Footer />
        </Suspense>
      </div>
    </div>
  );
}

export default App;
